import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IntegrationFragment } from './fragments'
import { IIntegration, IGeneratePayload, IRegenerateInput } from './types'
import handleFetchResult from '@utils/handleFetchResult'

const mutateHandler = handleFetchResult<IGeneratePayload, IIntegration>({
  handler: (data) => data.regenerateIntegration.integration,
  name: 'Integration',
})

export default function regenerate(input: IRegenerateInput): Promise<IIntegration> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation Regenerate($input: RegenerateIntegrationInput!) {
    regenerateIntegration(input: $input) {
      integration {
        ...IntegrationFragment
      }
    }
  }
  ${IntegrationFragment}
`
